<template>
  <div>
    <span v-if="rule.config.type == 1"
      >Match stocks that have underperformed the S&amp;P over {{ rule.config.months }} months:
      {{ rule.config.percentage_points }}
      {{ rule.config.percentage_points_max ? ' to ' + rule.config.percentage_points_max : '' }}
      percentage points
    </span>
    <span v-if="rule.config.type == 2"
      >Match stocks that have outperformed the S&amp;P over {{ rule.config.months }} months:
      {{ rule.config.percentage_points }}
      {{ rule.config.percentage_points_max ? ' to ' + rule.config.percentage_points_max : '' }}
      percentage points
    </span>
    <span v-if="rule.config.type == 3"
      >Match stocks that have underperformed the S&amp;P over {{ rule.config.months }} months:
      {{ rule.config.percent_threshold }}
      {{ rule.config.percent_threshold_max ? ' to ' + rule.config.percent_threshold_max : '' }}
      percent
    </span>
    <span v-if="rule.config.type == 4"
      >Match stocks that have outperformed the S&amp;P over {{ rule.config.months }} months:
      {{ rule.config.percent_threshold }}
      {{ rule.config.percent_threshold_max ? ' to ' + rule.config.percent_threshold_max : '' }}
      percent
    </span>
    <span v-if="!rule.config.type"
      >Old Rule: {{ rule.config.months }} months, Perf min: {{ rule.config.percent_threshold }},
      Perf max: {{ rule.config.percent_threshold_max }}, significance min:
      {{ rule.config.plus_minus }}, significance max: {{ rule.config.plus_minus_max }}
    </span>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  data() {
    return {
      ma_days: [],
      above_below: ['above', 'below'],
      high_low: ['new high', 'new low'],
      volume_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '90 Days', value: 90 }
      ],
      days_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '50 days', value: 50 },
        { text: '90 days', value: 90 },
        { text: '6-months', value: 180 },
        { text: '1 Year', value: 365 }
      ]
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  created() {},

  methods: {}
}
</script>
